import React, { useState, useEffect, useCallback } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const token = localStorage.getItem('authToken');
  const user = JSON.parse(localStorage.getItem("authUser"));

  const fetchUnreadCount = useCallback(async () => {
    try {
      let isAdmin;
      let userId;

      if (user?.Role === "Student") {
        isAdmin = 0;
        userId = user?.LoginId;
      } else {
        isAdmin = 1;
        userId = user?.Id;
      }

      const res = await fetch(`https://api.kunalsdrumclass.com/api/GetUnreadNotificationCount?userId=${userId}&isAdmin=${isAdmin}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
      );

      const result = await res.json();
      setTotalCount(result?.recordsets?.[0][0].TotalCount);
    } catch (error) {
      console.error("Unread count error:", error);
    }
  }, [token, user]);

  const fetchNotifications = useCallback(async () => {
    try {
      let isAdmin;
      let userId;

      if (user?.Role === "Student") {
        isAdmin = 0;
        userId = user?.Id;
      } else {
        isAdmin = 1;
        userId = user?.Id;
      }

      const res = await fetch(`https://api.kunalsdrumclass.com/api/GetLastNotifications?userId=${userId}&isAdmin=${isAdmin}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
      );

      const result = await res.json();
      setNotifications(result?.recordsets?.[0] || []);
    } catch (error) {
      console.error("Notifications error:", error);
    }
  }, [token, user]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchUnreadCount();
    }, 3000);

    return () => clearInterval(interval);
  }, [fetchUnreadCount]);

  useEffect(() => {
    if (!menu) return;

    fetchNotifications();

    const interval = setInterval(() => {
      fetchNotifications();
    }, 5000);

    return () => clearInterval(interval);
  }, [menu, fetchNotifications]);

  const updateCount = async () => {
    let isAdmin;
    let userId;

    if (user?.Role === "Student") {
      isAdmin = 0;
      userId = user?.LoginId;
    } else {
      isAdmin = 1;
      userId = user?.Id;
    }

    const payload = { userId: userId, isAdmin: isAdmin };
    await fetch("https://api.kunalsdrumclass.com/api/UpdateNotificationStatus", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="mdi mdi-bell-outline"></i>
          <span className="badge bg-danger rounded-pill">{totalCount > 100 ? "99+" : totalCount}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center justify-content-between">
              <Col xs="auto">
                <h6 className="m-0 font-size-15">{props.t("Notifications")} ({totalCount})</h6>
              </Col>

              <Col xs="auto">
                <Link
                  className="btn btn-sm btn-link font-size-14 btn-block text-center"
                  to="#" onClick={() => { updateCount() }}
                >
                  {" "}
                  {props.t("Mark All As Read")}{" "}
                </Link>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "auto" }}>
            {notifications.length === 0 ? (
              <div className="p-3 text-center text-muted">
                No notifications
              </div>
            ) : (
              notifications.map((item, index) => (
                <Link
                  key={index}
                  to="#"
                  className="text-reset notification-item"
                >
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-success rounded-circle font-size-16 p-3">
                        <i className="mdi mdi-bell-outline"></i>
                      </span>
                    </div>

                    <div className="flex-1">
                      <h6 className="mt-0 mb-1">
                        {item.Title}
                      </h6>

                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {item.Message}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/notifications"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};